import React, { useEffect } from "react";
import Header from "../Components/Header/Header";
import TermsOfServiceComp from "../Components/TermsOfService/TermsOfServiceComp";
import Footer from "../Components/Footer/Footer";

const TermsOfService = () => {
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
  }, []);

  return (
    <>
      <Header />
      <TermsOfServiceComp />
      <Footer />
    </>
  );
};

export default TermsOfService;
